module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-10.c63700ae.svg";